import React from 'react';

import SettingsTabs from '../../components/setting-tabs/setting-tabs';

const SettingsPage: React.FC = () => <SettingsTabs />;

export default SettingsPage;
